import React from 'react';
import { stats } from '../data/stats';
import { Reveal } from './Reveal';
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-137" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-138" data-mp="1ob57o37fegdo">
        {stats.map(({
        value,
        label
      }, index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-139" data-mp="1jeesdi3g3otb" data-mpi={index}>
            <span className="mb-1 font-display text-3xl font-black text-brand-navy md:text-4xl" data-id="element-140" data-mp="19lpkex73st2q">{value}</span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-141" data-mp="15lfgrr6saer1">{label}</span>
          </div>)}
      </Reveal>
    </section>;
}